import React from 'react';
import {
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalTitle,
  CloseButton, // Importamos o CloseButton estilizado
  ModalBody,
  InfoRow,
  InfoLabel,
  InfoValue
} from './modallstyle'; // Assegure-se de que o caminho está correto

// Importando o CloseIcon, o mesmo usado no modal de Novo Produto
import CloseIcon from '../../../../assets/produtcss/close.svg';

type ProductType = {
  id: number;
  code: string;
  name: string;
  collection: string;
  family: string;
  type: string; 
  colors: string;
  graduation: string;
  price?: string;
  status?: boolean;
};

interface PreviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  product: ProductType | null;
  onEdit: (product: ProductType) => void;
}

const ProductPreviewModal: React.FC<PreviewModalProps> = ({ isOpen, onClose, product, onEdit }) => {
  if (!isOpen || !product) return null;

  return (
    <ModalOverlay>
      <ModalContent>
        <ModalHeader>
          <ModalTitle>Resumo do Produto:</ModalTitle>
          {/* MUDANÇA AQUI: Usando o CloseButton com a imagem do ícone */}
          <CloseButton onClick={onClose}>
            <img src={CloseIcon} alt="Fechar" />
          </CloseButton>
        </ModalHeader>
        <ModalBody>
          <InfoRow>
            <InfoLabel>Código:</InfoLabel>
            <InfoValue>{product.code}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Nome:</InfoLabel>
            <InfoValue>{product.name}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Coleção:</InfoLabel>
            <InfoValue>{product.collection}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Família:</InfoLabel>
            <InfoValue>{product.family}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Grupo:</InfoLabel>
            <InfoValue>{product.type}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Cores:</InfoLabel>
            <InfoValue>{product.colors}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Graduação:</InfoLabel>
            <InfoValue>{product.graduation}</InfoValue>
          </InfoRow>
          <InfoRow>
            <InfoLabel>Preço:</InfoLabel>
            <InfoValue>{product.price}</InfoValue>
          </InfoRow>
          {product.status !== undefined && (
            <InfoRow>
              <InfoLabel>Status:</InfoLabel>
              <InfoValue>{product.status ? 'Ativo' : 'Inativo'}</InfoValue>
            </InfoRow>
          )}
        </ModalBody>

        <div style={{ padding: '20px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
          <button
            onClick={() => onEdit(product)}
            style={{
              padding: '10px 20px',
              backgroundColor: '#0D99FF',
              color: 'white',
              border: 'none',
              borderRadius: '20px',
              cursor: 'pointer',
              fontSize: '16px'
            }}
          >
            Editar Produto
          </button>
        </div>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ProductPreviewModal;